import React from 'react';
import ENVIRONMENT from 'src/utils/environments';
import { Tag } from 'antd';
import RequestIcon from 'src/screens/request/RequestIcon';

type CardType = 'default' | 'secondary' | 'primary' | 'gradient';

interface CardProps {
  request: any;
  renderButton: () => React.ReactElement;
  tagFormat?: 'flex' | 'bullet-list';
}

const cardColors: Record<CardType, string> = {
  default: '#FFFFFF',
  secondary: '#DCDBDB',
  primary: '#76B1DD',
  gradient: 'linear-gradient(135deg, #eef2ff, #f1efff)',
};

const RequestCard: React.FC<CardProps> = ({
  request,
  renderButton,
  tagFormat = 'flex',
}) => {
  const { id, name, description, imageUrl, card, tags } = request;

  const buttonElement = React.cloneElement(renderButton(), {
    className:
      'block rounded-md px-3.5 py-2.5 text-center text-sm bg-primary text-white !bg-primary !text-white flex h-[60px] w-full flex-col items-center justify-center gap-[0.35rem] duration-200 hover:bg-[#002c84]',
  });

  return (
    <div
      className="group relative flex h-full w-full flex-col items-start justify-start gap-2 overflow-hidden rounded-[0.75rem] text-left shadow-sm duration-300"
      style={{
        background: cardColors[card as CardType],
        ...(card === 'primary' ? { color: 'white' } : {}),
      }}
    >
      <div className="flex flex-col gap-2 p-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#E4EFFE]">
          <RequestIcon formId={id} style={{ width: 20 }} />
        </div>

        <h3 className="text-[22px] font-semibold">{name}</h3>
        <p className="text-xs">{description}</p>
      </div>

      <div className="mt-auto flex w-full items-center justify-center px-5">
        <img
          src={`${ENVIRONMENT.CDN_ASSETS_URL}/requests/main-stg/${imageUrl}`}
          alt={`${name}'s banner`}
          onError={(e) => {
            const target = e.currentTarget as HTMLImageElement;
            target.src = '/images/others.svg';
          }}
        />
      </div>

      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(112,210,240,0)_20%,rgba(112,210,240,0.6)_50%,rgba(112,210,240,1)_100%)] opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100" />

      <div
        className="absolute inset-0
          flex translate-y-4
          flex-col
          items-start
          justify-end
          gap-4
          p-5 text-white opacity-0
          transition-all
          duration-300
          ease-in-out group-hover:translate-y-0 group-hover:opacity-100
          "
      >
        <div
          className={`flex gap-1 ${
            tagFormat === 'flex'
              ? 'w-full flex-wrap'
              : 'w-auto flex-col items-start'
          }`}
        >
          {tags?.map((tag: string) => (
            <Tag
              key={tag}
              bordered={false}
              style={{
                color: 'black',
                background: 'white',
                border: '1px solid rgba(29, 29, 29, 0.25)',
                borderRadius: '8px',
                margin: 0,
                fontSize: '12px',
                padding: '2px 8px',
              }}
            >
              {tag}
            </Tag>
          ))}
        </div>

        {buttonElement}
      </div>
    </div>
  );
};

export default RequestCard;
